'use client';

import React from 'react';

interface SpeedGaugeProps {
  speed: number; // 0–100
}

export default function SpeedGauge({ speed }: SpeedGaugeProps) {
  const segments = 10;
  const filled = Math.round((speed / 100) * segments);
  const isMaxSpeed = speed >= 90;

  return (
    <div className="hud-glass rounded-xl px-2 py-2 flex flex-col items-center gap-1.5" style={{ minWidth: '44px' }}>
      <p
        className="text-[9px] font-medium tracking-widest uppercase"
        style={{ color: '#556677', fontFamily: 'DM Sans, sans-serif', writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}
      >
        Speed
      </p>
      <div className="flex flex-col-reverse gap-0.5">
        {Array.from({ length: segments }).map((_, i) => {
          const segIndex = i;
          const active = segIndex < filled;
          const color =
            segIndex >= 8 ? '#ff4d6d' :
            segIndex >= 5 ? '#ffd60a': '#00e5ff';
          return (
            <div
              key={`speed-seg-${segIndex}`}
              className="rounded-sm transition-all duration-75"
              style={{
                width: '14px',
                height: '5px',
                background: active ? color : 'rgba(255,255,255,0.06)',
                boxShadow: active ? `0 0 4px ${color}` : 'none',
              }}
            />
          );
        })}
      </div>
      <p
        className="font-mono-game text-[11px] font-bold"
        style={{ color: isMaxSpeed ? '#ff4d6d' : '#00e5ff' }}
      >
        {speed}
      </p>
    </div>
  );
}